
import { Transaction } from '../store/types';

export const convertTransactionsToTable = (transactions: Transaction[] | undefined = []) => transactions.map((item) => ({
  ...item,
  key: item.id,
}));


